<template>
  <div class="flex items-center justify-center h-full">
    <vs-switch
      :color="params.data.isActive ? 'success' : ''"
      @input="onToggle"
      v-model="params.data.isActive"
    />
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "VolunteerStatusSwitch",
  methods: {
    onToggle() {
      this.params.switchAction(this.params.data);
    }
  }
});
</script>

<style scoped>
.vs-switch-primary {
  background: #d94d4d;
}
</style>
